import { RecupererRapport } from "./RecupererRapport";
import { useApp } from "../state/AppState";

/**
 * L'écran qui remplace le vide.
 *
 * Quatre vues du parcours ne s'affichaient que si leurs données étaient encore
 * en mémoire — les tâches et les trois résultats. L'historique du navigateur,
 * lui, restaure la **vue** sans les données : après un rechargement, un retour
 * ramenait sur un écran qui ne rendait rien du tout. En-tête, pied de page, et
 * rien entre les deux. Aucun message, aucune sortie.
 *
 * Le chemin n'avait rien d'exotique : sur Android, « tirer pour rafraîchir »
 * part tout seul au moindre geste vers le haut, et le réflexe suivant est de
 * presser retour pour retrouver son résultat.
 *
 * Le diagnostic n'est pas conservé — c'est voulu, rien de nominatif n'est
 * stocké et le résultat n'a pas d'adresse propre qui pourrait être partagée
 * sans qu'on l'ait choisi. Reste à le dire, et à rouvrir le chemin.
 */
export function Reprise() {
  const { goTo, achat, openPay } = useApp();

  return (
    <section>
      <div className="shell narrow app">
        <h2>Ce résultat n'est plus en mémoire</h2>
        <p className="sub">
          La page a été rechargée entre-temps, et ce résultat n'y est plus. Nous ne gardons ni
          nom, ni numéro, ni adresse ; seul votre indice précédent peut vous être rappelé au prochain
          passage. Le refaire prend le même temps que la première fois.
        </p>

        <button type="button" className="btn" onClick={() => goTo("s-t1")}>
          Refaire mon diagnostic
        </button>

        {/*
          L'achat, lui, survit au rechargement : il est le seul élément retenu
          par le navigateur. Quelqu'un qui a payé et qui atterrit ici doit
          repartir avec son rapport, pas avec un formulaire.
        */}
        {achat && (
          <>
            <p className="fine" style={{ marginTop: "18px" }}>
              Un paiement est enregistré sur cet appareil. Votre rapport ne dépend pas de l'écran
              ci-dessus : il est déjà rédigé à partir de ce que vous aviez renseigné.
            </p>
            <button type="button" className="btn btn-brass" onClick={() => openPay(achat.plan)}>
              Récupérer mon rapport
            </button>
          </>
        )}

        {/*
          La voie qui ne dépend pas de cet appareil.

          Le bloc ci-dessus tient à `achat`, c'est-à-dire au stockage de ce
          navigateur. Or quelqu'un qui atterrit ici après un rechargement peut
          tout aussi bien être arrivé sur un autre téléphone, ou avoir nettoyé
          le sien : dans ce cas le bloc ne s'affiche pas du tout, et l'écran lui
          propose de refaire un diagnostic qu'il a déjà payé.
        */}
        <RecupererRapport plan={achat?.plan ?? "report"} />

        <button type="button" className="back" onClick={() => goTo("home")}>
          ← Revenir à l'accueil
        </button>
      </div>
    </section>
  );
}
